import React from "react";
import { FormProvider } from "react-hook-form";
import { FormHelperText, Stack } from "@mui/material";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import WorkflowSteps from "./WorkflowSteps";
import { useResponsive } from "../../../../../hooks/useResponsive";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { RFHTextField } from "../../../../../components/RFH";
import { AddRoundedIcon } from "../../../../../utils/constants/icons";
import { useCreateWorkflowForm } from "../../hooks/useCreateWorkflowForm";

function CreateWorkflow({
  open,
  close,
  workflowData = null,
  edit= false,
  workflowId = "",
}) {
  const isMobile = useResponsive("down", "md");
  const {
    control,
    handleSubmit,
    formState: { errors },
    fields,
    remove,
    handleOnDragEnd,
    handleAddStep,
    onSubmit,
    ...methods
  } = useCreateWorkflowForm({
    close,
    workflowData,
    edit,
    workflowId,
  });

  return (
    <React.Fragment>
      <FormProvider control={control} {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormDialog
            open={open}
            handleClose={() => close(false)}
            title={edit ? <p>Edit Workflow</p> : <p>Create Workflow</p>}
            buttonTxt={edit ? "Update" : "Create"}
            handleSubmit={handleSubmit(onSubmit)}
            className="create-workflow-dialog"
            PaperProps={{
              className: "create-workflow-paper",
            }}
            cancelBtn={true}
            fullWidth={true}
            width={470}
          >
            <div>
              <div className="workflowName">
                <p>Workflow Name</p>
                <RFHTextField
                  id="outlined-basic"
                  variant="outlined"
                  name="workflow_name"
                  className="workflow-input"
                  defaultPadding={false}
                  inputProps={{
                    padding: isMobile && "8.5px 12px",
                  }}
                  FormHelperTextProps={{
                    className: "helper-text",
                  }}
                  required
                />
              </div>
              <Stack
                direction="row"
                justifyContent={!isMobile && "space-evenly"}
                alignItems="start"
              >
                <p className="workflow-step-names">Workflow Steps</p>
                <p className="workflow-step-names">Generic Steps</p>
              </Stack>
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="dragbaleSteps">
                  {(provided) => (
                    <div
                      className="addWorkflowSteps"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      <WorkflowSteps
                        fields={fields}
                        remove={remove}
                        errors={errors}
                        edit={edit}
                        close={close}
                      />
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              <div className="addWorkflowSteps cursor-pointer">
                <div
                  className="addWorkflowstepButton"
                  onClick={handleAddStep}
                >
                  <AddRoundedIcon className="add-icon"/>
                  <span>Add Step</span>
                </div>
              </div>
              <FormHelperText
                error={!!errors?.workflow_steps?.message}
                className="error-text"
              >
                {errors?.workflow_steps?.message}
              </FormHelperText>
            </div>
          </FormDialog>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default React.memo(CreateWorkflow);
